// @ts-strict-ignore
import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Box, Button, Illustration } from '@node-space/ui-components'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { WalletTypes } from 'types/types'
import {
  totalNumberOfPayoutsAtom,
  totalPaymentsAtom,
  walletTypeAtom,
} from '../atoms/massPayoutAtoms'

export const MassPayoutsUploadSuccess = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { reference: batchId } = useParams()
  const action = useAtomValue(actionAtom)
  const totalPayments = useAtomValue(totalPaymentsAtom)
  const totalNumberOfPayouts = useAtomValue(totalNumberOfPayoutsAtom)
  const walletType = useAtomValue(walletTypeAtom)
  const cryptoPayout = walletType === WalletTypes.CRYPTO

  const numberOfPayments = cryptoPayout ? (totalNumberOfPayouts ?? totalPayments) : totalPayments

  const handleClose = () => {
    queryClient.invalidateQueries({ queryKey: reactQueryKeys.massCryptoPayoutById(batchId) })
    action?.onClose()
  }

  return (
    <Box data-testid="upload-successful">
      <Box flexCol align="center" paddingB={24} paddingX={32} gap={12}>
        <Illustration name="HandsClapping" color="success" />
        <h1 className="text-foreground-prominent text-h1">{t('paymentSubmitted')}</h1>
        <span className="text-foreground-prominent text-body-regular">
          {`${numberOfPayments} payments have been successfully submitted and are on their way to your recipients.`}
        </span>
        <span className="text-foreground-prominent text-body-regular">
          {cryptoPayout
            ? 'You can track the payments in Transaction history.'
            : t('massPayouts.trackPayments')}
        </span>
        <Button testId="done" onClick={handleClose}>
          {t('done')}
        </Button>
      </Box>
    </Box>
  )
}
